import { useQuery } from '@apollo/client';

import { AUDIENCE_UNIVERSE_SIZE_QUERY } from '../queries';

/**
 * Approximate size of the US consumer universe (ATAD-134).
 *
 * Returns null when the value can't be fetched, and callers MUST treat null as
 * "don't warn" rather than substituting a default. This drives an advisory
 * warning only: failing open costs a missed nudge, while guessing a
 * denominator could tell a user their perfectly reasonable audience is half
 * the country. `errorPolicy: 'all'` keeps a failure here from surfacing as a
 * page-level error in the builder.
 *
 * cache-first because the number moves at most quarterly — there is no reason
 * to re-fetch it as the user works.
 */
export default function useAudienceUniverseSize(): number | null {
  const { data } = useQuery(AUDIENCE_UNIVERSE_SIZE_QUERY, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  return data?.audienceUniverseSize ?? null;
}
